'use strict';

/**
 * Service for lazy loading external JavaScript files at runtime.
 * Used primarily for loading keycloak.js dynamically when needed.
 *
 * Shared across QuartzX legacy projects. Keep in sync with QuartzX.Web.IAM.Legacy.
 *
 * @module services.lazyLoadScript
 */
angular.module('services.lazyLoadScript', [])

.factory('lazyLoadScriptService', ['$q', '$document', function ($q, $document) {
    var service = {};
    var loadedScripts = {}; // Track loaded scripts to prevent duplicates

    /**
     * Loads an external JavaScript file dynamically.
     * Returns a promise that resolves when the script is loaded.
     * If the script was already loaded, returns an already-resolved promise.
     *
     * @param {string} url - The URL of the script to load
     * @returns {Promise} Promise that resolves when script is loaded, rejects on error
     */
    service.loadScript = function(url) {
        var deferred = $q.defer();

        // Check if script was already loaded (in-memory cache)
        if (loadedScripts[url]) {
            deferred.resolve();
            return deferred.promise;
        }

        // Check if script already exists in DOM (handles page reloads)
        var existingScripts = $document[0].getElementsByTagName('script');
        for (var i = 0; i < existingScripts.length; i++) {
            if (existingScripts[i].src && existingScripts[i].src.indexOf(url) !== -1) {
                loadedScripts[url] = true;
                deferred.resolve();
                return deferred.promise;
            }
        }

        // Create script element
        var script = $document[0].createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;

        script.onload = function() {
            loadedScripts[url] = true;
            deferred.resolve();
        };

        script.onerror = function(error) {
            console.error('[lazyLoadScriptService] Failed to load script:', url, error);
            deferred.reject(new Error('Failed to load script: ' + url));
        };

        $document[0].head.appendChild(script);

        return deferred.promise;
    };

    /**
     * Check if a script has already been loaded.
     *
     * @param {string} url - The URL of the script to check
     * @returns {boolean} True if script was loaded, false otherwise
     */
    service.isScriptLoaded = function(url) {
        return !!loadedScripts[url];
    };

    return service;
}]);
